import { render, staticRenderFns } from "./CreateESGModule.vue?vue&type=template&id=1e246738"
import script from "./CreateESGModule.vue?vue&type=script&lang=js"
export * from "./CreateESGModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports